import API from '@/api/path'
import { baseFetch } from '@/api/axiosBase'

const loginModule = {
  state: {
    // 社區列表
    communityList: []
  },
  actions: {
    // 取得社區列表
    async GET_COMMUNITIES({ commit, state, rootState }, payload) {
      // console.log('GET_COMMUNITIES payload: ', payload)
      try {
        const res = await baseFetch(
          API.getCommunities.url,
          API.getCommunities.method,
          payload
        )
        if (!res.isError && res.data) {
          commit('SET_COMMUNITIES', res.data.data)
          let communityIdCache = localStorage.getItem('COMMUNITY_ID')
          if (communityIdCache) {
            commit('commonModule/SET_CURRENT_COMMUNITY_ID', communityIdCache, { root: true })
          } else if (res.data.data[0]) {
            commit('commonModule/SET_CURRENT_COMMUNITY_ID', res.data.data[0].communityId, { root: true })
            localStorage.setItem('COMMUNITY_ID', res.data.data[0].communityId)
          }
          const communityObj = state.communityList.find(
            (it) => it.communityId === rootState.commonModule?.currentCommunityId
          )
          commit('commonModule/SET_CURRENT_COMMUNITY_NAME', communityObj?.communityName, { root: true })
        }
      } catch (error) {
        console.error('error', error)
      }
    }
  },
  mutations: {
    // 儲存社區列表
    SET_COMMUNITIES(state, payload) {
      state.communityList = payload
    }
  },
  getters: { getCommunities: (state) => state.communityList },
  namespaced: true
}

export default loginModule
